import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
// import { validateUrl } from '../utils';

export default function IconWrapper({ Component, src, ...props }) {
  const [downloadedSrc, setDownloadedSrc] = useState(null);

  useEffect(() => {
    if (!src) {
      setDownloadedSrc(null);
      return;
    }
    axios
      .get(src, { responseType: 'blob' })
      .then((response) => {
        const url = URL.createObjectURL(response.data);
        if(localStorage.getItem('showUrl') === 'true') {
          console.log('Downloaded icon from:', src);
          console.log('local url:', url);
        }
        setDownloadedSrc(url);
      })
      .catch(() => {
        setDownloadedSrc(null);
      });
    return () => {
      if (downloadedSrc) {
        URL.revokeObjectURL(downloadedSrc);
      }
    };
    // eslint-disable-next-line
  }, [src]);

  return downloadedSrc && <Component {...props} src={downloadedSrc} />;
}

IconWrapper.propTypes = {
  Component: PropTypes.elementType.isRequired,
  src: PropTypes.string,
};
